/**
 *  A C T I O N S  (dispatch)
 *  https://vuex.vuejs.org/en/actions.html
 */

import ConfigService from '@/services/ConfigService'
import FacilityService from '@/services/FacilityService'
import IsoService from '@/services/IsoService'
import UtilityService from '@/services/UtilityService'

const actions = {
  /**
   *  Housekeeping
   */
  resetState({ commit }) {
    commit('RESET_STATE')
  },

  /**
   *  User selects a different facility from drop down which
   *  resets state and reloads new facility data (including
   *  programs and configuration data)
   */
  changeFacility: ({ commit, getters }, payload) => {
    /* facility */
    /* same one?  ignore. */
    let storedFacilityId = getters.getFacilityId
    if (storedFacilityId === payload.facility.facility_id) {
      // console.log('same facility, ignoring')
      return
    }
    commit('SET_FACILITY', payload)

    FacilityService.getPrograms(payload.facility.facility_id)
      .then(response => {
        if (response.data) {
          if (response.data.length > 0) {
            commit('SET_PROGRAMS', { programs: response.data })
          }
        }
      })
      .catch(error => {
        // what ?
      })

    /* ncp ceiling; might not be one .. and that's ok */
    let key = 'NCP_CEILING_FACILITY_' + getters.getFacilityId
    ConfigService.getValue(key).then(response => {
      console.log("NCP_CEILING_FACILITY_" + getters.getFacilityId + "=" + response.data.value)
      if (response.data.value) {
        console.log("setting ....")
        commit('SET_NCP_CEILING', { ceiling: response.data.value })
      }

      /* threshold */
      key = 'FACILITY_' + getters.getFacilityId + '_ALERT_VALUE_THRESHOLD'
      ConfigService.getValue(key)
        .then(response => {
          commit('SET_FACILITY_THRESHOLD', { threshold: response.data.value })

          /* utility */
          UtilityService.getUtility(getters.getFacility.utility_id)
            .then(response => {
              commit('SET_UTILITY', { utility: response.data })

              /* iso */
              IsoService.getIso(getters.getUtility.iso_id)
                .then(response => {
                  commit('SET_ISO', { iso: response.data })
                })
                .catch(error => {
                  // what ?
                })
            })
            .catch(error => {
              // what ?
            })
        })
        .catch(error => {
          // what ?
        })
    })
  }
}

export default actions
